export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 mx-0 md:mx-5 md:my-5 md:rounded-[28px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dreamy%20soft%20focus%20fashion%20lifestyle%20composition%20with%20floating%20fabric%20textures%20and%20abstract%20product%20silhouettes%20in%20warm%20cream%20and%20sage%20green%20tones%2C%20gentle%20bokeh%20lighting%20effect%2C%20ethereal%20minimalist%20aesthetic%2C%20sophisticated%20editorial%20art%20direction%2C%20Western%20contemporary%20fashion%20atmosphere%2C%20clean%20airy%20composition%20with%20subtle%20depth%20layers%2C%20premium%20brand%20campaign%20visual%20style%2C%20elegant%20and%20calming%20mood%2C%20organic%20flowing%20shapes%20creating%20visual%20interest&width=1600&height=900&seq=hero-bg-vb-v2-2026z&orientation=landscape"
          alt="Vigorbuy Spreadsheet fashion product discovery guide background"
          title="Vigorbuy Spreadsheet Complete Guide 2026"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center text-center">
        {/* Pill Tag */}
        <div className="inline-flex items-center px-5 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6 md:mb-8 animate-[fadeInUp_0.6s_ease]">
          <i className="ri-sparkling-line text-white/90 text-sm mr-2"></i>
          <span className="text-xs md:text-sm text-white/90 font-medium tracking-wide">
            Updated for 2026
          </span>
        </div>

        {/* H1 */}
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-[1.15] tracking-tight max-w-4xl animate-[fadeInUp_0.6s_ease_0.1s]">
          Vigorbuy Spreadsheet: The Complete Guide
          <br />
          <span className="text-white/80 font-light">
            for Smart Product Discovery
          </span>
        </h1>

        {/* Subtitle */}
        <p className="mt-5 md:mt-7 text-sm md:text-lg text-white/75 max-w-2xl leading-relaxed animate-[fadeInUp_0.6s_ease_0.2s]">
          Discover categories, comparisons, guides, and safety information about
          Vigorbuy Spreadsheet — your organized resource for efficient fashion
          product exploration.
        </p>

        {/* Feature pills */}
        <div className="flex flex-wrap items-center justify-center gap-2 md:gap-3 mt-5 md:mt-6 animate-[fadeInUp_0.6s_ease_0.3s]">
          {[
            "Updated Resources",
            "Beginner Friendly",
            "Category Guides",
            "Comparison Tables",
            "Safety Information",
          ].map((feat) => (
            <span
              key={feat}
              className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-white/10 border border-white/15 text-xs text-white/80"
            >
              <i className="ri-check-line text-accent-400 text-xs"></i>
              {feat}
            </span>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center gap-3 md:gap-4 mt-8 md:mt-10 animate-[fadeInUp_0.6s_ease_0.4s]">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/20"
          >
            Vigorbuy Sheet
            <i className="ri-arrow-right-up-line text-sm group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-200"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="group inline-flex items-center gap-2 px-7 py-3.5 bg-accent-500 text-background-50 text-sm md:text-base font-semibold rounded-full hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-accent-500/20"
          >
            Buy It Now
            <i className="ri-shopping-bag-line text-sm group-hover:translate-x-0.5 transition-transform duration-200"></i>
          </a>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 md:bottom-10 left-1/2 -translate-x-1/2 animate-[bounce_2s_ease_infinite]">
          <a
            href="#what-is"
            className="w-10 h-10 flex items-center justify-center rounded-full bg-white/10 backdrop-blur-sm border border-white/20 text-white/70 hover:text-white hover:bg-white/20 transition-all duration-200"
          >
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}